import React from "react";
import ReactDOM from "react-dom";
import Documentation from "./components/documentation";

const documentation = document.getElementById("documentation");

ReactDOM.render(<Documentation />, documentation);
